var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { r as registerInstance, h, g as getElement, c as createEvent, H as Host } from './core-39f715ab.js';
import { i as isScreen, g as getScreenSize } from './index-0a6434c2.js';
import { c as cloneDeep } from './cloneDeep-776637cd.js';
import { d as debounce } from './debounce-b2405f18.js';
import { P as Popper } from './popper-2f5d1dc1.js';
import { N as NAVIGATION_KEYS, E as ESCAPE_KEY, a as DOWN_KEY, U as UP_KEY } from './index-57e53583.js';
import { r as randomUID } from './index-f8717a8b.js';
var RaulCheckbox = /** @class */ (function () {
    function RaulCheckbox(hostRef) {
        registerInstance(this, hostRef);
        /**
         * If `true`, the checkbox border will become red. This can be useful for form validations.
         */
        this.invalid = false;
        /**
         * If `true`, the checkbox size will be small.
         */
        this.small = false;
    }
    RaulCheckbox.prototype.render = function () {
        return (h("div", { class: {
                'r-checkbox': true,
                'r-checkbox--invalid': this.invalid,
                'r-checkbox--small': this.small
            } }, h("label", { class: "r-checkbox__label" }, h("slot", null), h("div", { class: "r-checkbox__label__icon" }), this.labelText &&
            h("div", { class: "r-checkbox__label__text" }, this.labelText))));
    };
    Object.defineProperty(RaulCheckbox.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaulCheckbox, "style", {
        get: function () { return "raul-checkbox{display:inline-block;vertical-align:middle;font-size:.875rem}raul-checkbox .r-checkbox__label{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;position:relative}raul-checkbox .r-checkbox__label input[type=checkbox]{position:absolute;height:0;opacity:0;width:0;z-index:-10}raul-checkbox .r-checkbox__label input[type=checkbox]:checked~.r-checkbox__label__icon,raul-checkbox .r-checkbox__label input[type=checkbox]:indeterminate~.r-checkbox__label__icon{--bg-opacity:1;background-color:#0076cc;background-color:rgba(0,118,204,var(--bg-opacity));--border-opacity:1;border-color:#0076cc;border-color:rgba(0,118,204,var(--border-opacity))}raul-checkbox .r-checkbox__label input[type=checkbox]:checked~.r-checkbox__label__icon:after{position:absolute;border-left-width:2px;border-top-width:2px;--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity));content:\"\";height:13px;left:7px;top:14px;-webkit-transform:rotate(-135deg);transform:rotate(-135deg);-webkit-transform-origin:0 0;transform-origin:0 0;width:7px}raul-checkbox .r-checkbox__label input[type=checkbox]:indeterminate~.r-checkbox__label__icon:after{position:absolute;border-top-width:2px;--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity));left:50%;top:50%;content:\"\";-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:10px}raul-checkbox .r-checkbox__label input[type=checkbox]:disabled~.r-checkbox__label__icon{--bg-opacity:1;background-color:#ebedee;background-color:rgba(235,237,238,var(--bg-opacity));--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity))}raul-checkbox .r-checkbox__label input[type=checkbox]:disabled:checked~.r-checkbox__label__icon:after,raul-checkbox .r-checkbox__label input[type=checkbox]:disabled:indeterminate~.r-checkbox__label__icon:after{--border-opacity:1;border-color:#9ba3a7;border-color:rgba(155,163,167,var(--border-opacity))}body[modality] raul-checkbox .r-checkbox__label input[type=checkbox]:focus~.r-checkbox__label__icon:before{position:absolute;border-radius:.125rem;top:-4px;right:-4px;bottom:-4px;left:-4px;-webkit-box-shadow:0 0 0 1px #0076cc;box-shadow:0 0 0 1px #0076cc;content:\"\"}raul-checkbox .r-checkbox__label__icon{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity));border-width:1px;--border-opacity:1;border-color:#c6ccd0;border-color:rgba(198,204,208,var(--border-opacity));-ms-flex:none;flex:none;position:relative;border-radius:.125rem;height:20px;-webkit-transition:background-color .15s linear,border-color .15s linear;transition:background-color .15s linear,border-color .15s linear;width:20px}raul-checkbox .r-checkbox__label__text{font-size:.875rem;margin-left:.5rem;word-break:break-all}raul-checkbox .r-checkbox--small .r-checkbox__label__icon{height:14px;width:14px}raul-checkbox .r-checkbox--small .r-checkbox__label input[type=checkbox]:checked~.r-checkbox__label__icon:after{height:10px;width:5px;left:4px;top:10px}raul-checkbox .r-checkbox--small .r-checkbox__label input[type=checkbox]:indeterminate~.r-checkbox__label__icon:after{width:7px}raul-checkbox .r-checkbox--invalid .r-checkbox__label__icon{border-width:1px;--border-opacity:1;border-color:#d01a1f;border-color:rgba(208,26,31,var(--border-opacity))}"; },
        enumerable: true,
        configurable: true
    });
    return RaulCheckbox;
}());
var Dot = function (props) { return h("div", { class: "r-container-loader__dot", style: { animationDelay: props.animationDelay } }); };
var RaulcontainerLoader = /** @class */ (function () {
    function RaulcontainerLoader(hostRef) {
        registerInstance(this, hostRef);
    }
    RaulcontainerLoader.prototype.render = function () {
        return (h("div", { class: "r-container-loader__container" }, h("div", { class: "r-container-loader__dots-container" }, Array.from({ length: 3 }).map(function (_, index) { return h(Dot, { animationDelay: index * 333 + "ms" }); }))));
    };
    Object.defineProperty(RaulcontainerLoader, "style", {
        get: function () { return "raul-container-loader{display:block;font-size:.875rem}raul-container-loader .r-container-loader__container{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;z-index:50;background-color:hsla(0,0%,100%,.8)}raul-container-loader .r-container-loader__container .r-container-loader__dots-container{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;opacity:1;width:3rem}raul-container-loader .r-container-loader__container .r-container-loader__dot{--bg-opacity:1;background-color:#c6ccd0;background-color:rgba(198,204,208,var(--bg-opacity));border-radius:9999px;-webkit-animation:color-change 1s linear infinite;animation:color-change 1s linear infinite;height:10px;width:10px}\@-webkit-keyframes color-change{0%{--bg-opacity:1;background-color:#0076cc;background-color:rgba(0,118,204,var(--bg-opacity))}20%{--bg-opacity:1;background-color:#0076cc;background-color:rgba(0,118,204,var(--bg-opacity))}50%{--bg-opacity:1;background-color:#c6ccd0;background-color:rgba(198,204,208,var(--bg-opacity))}to{--bg-opacity:1;background-color:#c6ccd0;background-color:rgba(198,204,208,var(--bg-opacity))}}\@keyframes color-change{0%{--bg-opacity:1;background-color:#0076cc;background-color:rgba(0,118,204,var(--bg-opacity))}20%{--bg-opacity:1;background-color:#0076cc;background-color:rgba(0,118,204,var(--bg-opacity))}50%{--bg-opacity:1;background-color:#c6ccd0;background-color:rgba(198,204,208,var(--bg-opacity))}to{--bg-opacity:1;background-color:#c6ccd0;background-color:rgba(198,204,208,var(--bg-opacity))}}"; },
        enumerable: true,
        configurable: true
    });
    return RaulcontainerLoader;
}());
var RaulOption = /** @class */ (function () {
    function RaulOption(hostRef) {
        registerInstance(this, hostRef);
        this.raulOptionClick = createEvent(this, "raulOptionClick", 7);
    }
    RaulOption.prototype.handleOptionClick = function () {
        this.raulOptionClick.emit({
            custom: !!this.custom,
            selected: this.selected,
            indeterminate: this.indeterminate,
            focused: this.focused,
            disabled: this.disabled,
            value: this.value,
            text: this.text,
            description: this.description,
            'option-id': this.optionId
        });
    };
    RaulOption.prototype.render = function () {
        var _this = this;
        var renderCustomOption = function () {
            return (h("div", { class: {
                    'r-option': true,
                    'r-option--disabled': _this.disabled,
                    'r-option--group': _this.variant === 'group',
                    'r-option--heading': _this.variant === 'heading',
                    'r-option--sub-option': _this.variant === 'sub-option',
                    'r-option--with-description': !!_this.description
                }, role: "option", tabindex: "-1", id: _this.optionId, "aria-selected": _this.selected ? 'true' : 'false', "aria-disabled": _this.disabled ? 'true' : null, onClick: function () { return _this.handleOptionClick(); } }, _this.icon && h("raul-icon", { class: "r-option__icon", icon: _this.icon, kind: _this.iconKind }), h("div", { class: "r-option__text" }, h("div", { class: "r-option__text__title", title: _this.text }, _this.text), _this.description && h("div", { class: "r-option__text__description", title: _this.description }, _this.description)), h("slot", null)));
        };
        if (this.custom) { // custom raul-option
            return renderCustomOption();
        }
        else { // data-driven raul-option
            return (h(Host, { class: {
                    'r-option': true,
                    'r-option--multiple': this.multiple,
                    'r-option--active': this.focused,
                    'r-option--disabled': this.disabled,
                    'r-option--selected': this.selected,
                    'r-option--group': this.variant === 'group',
                    'r-option--heading': this.variant === 'heading',
                    'r-option--sub-option': this.variant === 'sub-option',
                    'r-option--with-description': !!this.description
                }, role: "option", tabindex: "-1", id: this.optionId, "aria-selected": this.selected ? 'true' : 'false', "aria-disabled": this.disabled ? 'true' : null, onClick: function () { return _this.handleOptionClick(); } }, this.icon && h("raul-icon", { class: "r-option__icon", icon: this.icon, kind: this.iconKind }), h("div", { class: "r-option__text" }, h("div", { class: "r-option__text__title", title: this.text }, this.text), this.description && h("div", { class: "r-option__text__description", title: this.description }, this.description)), this.multiple
                ? h("raul-checkbox", { small: true }, h("input", { type: "checkbox", tabindex: "-1", "aria-hidden": "true", checked: this.selected, disabled: this.disabled, value: this.value, ref: function (el) { return el && (el.indeterminate = _this.indeterminate); } }))
                : this.selected && h("span", { class: "r-option__check-mark" })));
        }
    };
    return RaulOption;
}());
var RaulSelect = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        this.popper = null;
        this.selectAllId = "option-" + randomUID();
        this.startPosition = 1;
        this.endPosition = 10;
        this.filteredOptions = [];
        this.searchInputId = "search-" + randomUID();
        this.opened = false;
        this.expanded = false;
        this.searchQuery = '';
        this.isNoScroll = false;
        this.processedOptions = [];
        this.isFocused = false;
        /**
         * If `true`, the user cannot interact with the select.
         */
        this.disabled = false;
        /**
         * The "overflow" prop can be used in custom select to prevent custom select menu overflow be cut off.
         */
        this.overflow = false;
        /**
         * If `true`, allows multiple selections.
         */
        this.multiple = false;
        /**
         * The name of the control, which is submitted with the form data.
         */
        this.name = "select-" + randomUID();
        /**
         * The text label.
         */
        this.label = null;
        /**
         * The text to display when the select value is empty.
         */
        this.placeholder = 'Select an option';
        /**
         * If `true`, adds a search field at the top of the select menu.
         */
        this.searchable = false;
        /**
         * If `true`, removes select toggle border.
         */
        this.borderless = false;
        /**
         * If `true`, removes select toggle border and styles to match the page header style.
         */
        this.header = false;
        /**
         * The value of the select.
         */
        this.value = this.multiple ? [] : '';
        /**
         * Options and groups of the select.
         */
        this.options = [];
        /**
         * Options menu's placement.
         */
        this.menuPlacement = 'bottom-start';
        /**
         * If `true` the menu position will be 'fixed'.
         */
        this.menuPositionFixed = false;
        /**
         * The look of the select field.
         */
        this.variant = 'select';
        /**
         * If `true` loading overlay will be appended to select dropdown menu
         */
        this.loading = false;
        /**
         * No options message.
         */
        this.noOptionsMessage = 'No results found';
        /**
         * If `true` `noOptionsMessage` will be appended to select dropdown menu
         */
        this.showNoOptionsMessage = false;
        /**
         * Allows to insert custom raul-options.
         * For custom raul-select the following props are not available - multiple, searchable, options, variant.
         */
        this.custom = false;
        /**
         * Allows for compact floating label support. Requires lable property.
         */
        this.compact = false;
        /**
         * Allows for override of diplayed value in the select box.
         */
        this.customValue = null;
        /**
         * Adds inputs with hidden type for each value of select.
         */
        this.hiddenInput = false;
        this.textInput = false;
        this.raulSelectOpen = createEvent(this, "raulSelectOpen", 7);
        this.raulSelectClose = createEvent(this, "raulSelectClose", 7);
        this.raulChange = createEvent(this, "raulChange", 7);
        this.positionCaret = createEvent(this, "positionCaret", 7);
    }
    class_1.prototype.optionsChanged = function () {
        if (this.custom) {
            return;
        }
        this.selectAllId = "option-" + randomUID();
        this.setOptionsId();
        this.processedOptions = [];
        this.processOptions(this.startPosition, this.endPosition);
    };
    class_1.prototype.valueChanged = function () {
        this.validateValue();
    };
    class_1.prototype.multipleChanged = function () {
        if (!this.value)
            this.setInitialValue();
    };
    class_1.prototype.componentWillLoad = function () {
        if (!this.custom) {
            this.setOptionsId();
            this.setInitialValue();
            this.processOptions(this.startPosition, this.endPosition);
        }
        this.validateValue();
        this.handleDebouncedResize = debounce(this.handleDebouncedResize, 200);
    };
    class_1.prototype.componentDidLoad = function () {
        this.isNoScroll = document.body.classList.contains('no-scroll');
    };
    class_1.prototype.handleKeyDown = function (e) {
        if (NAVIGATION_KEYS.includes(e.key) && !this.variant.includes("time-picker")) {
            e.preventDefault();
            this.opened ? this.focusOption(e.key) : this.open();
        }
        else if (ESCAPE_KEY.includes(e.key)) {
            this.close();
        }
    };
    class_1.prototype.handleClickAndFocusOutside = function (e) {
        if (this.opened && !this.selectEl.contains(e.target)) {
            this.close();
        }
    };
    class_1.prototype.handleDebouncedResize = function () {
        if (this.opened) {
            isScreen('sm') ? this.createPopper() : this.destroyPopper();
        }
    };
    class_1.prototype.handlePositionCaret = function (e) {
        console.log('handlePositionCaret', e);
        this.selectInputEl.selectionStart = 3;
        console.log('selectionStart', this.selectInputEl.selectionStart);
    };
    /**
     * Open the select menu.
     */
    class_1.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                this.opened = true;
                setTimeout(function () {
                    _this.expanded = true;
                    if (isScreen('sm')) {
                        _this.createPopper();
                    }
                    if (!_this.custom && _this.searchable) {
                        _this.clearSearch();
                    }
                    _this.raulSelectOpen.emit({ value: _this.value });
                    _this.isNoScroll = document.body.classList.contains('no-scroll');
                    if (getScreenSize() == 'sm' && !_this.isNoScroll)
                        document.body.classList.add('no-scroll');
                }, 100);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Close the select menu.
     */
    class_1.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transitionDuration;
            var _this = this;
            return __generator(this, function (_b) {
                transitionDuration = parseFloat(window.getComputedStyle(this.selectMenuEl).transitionDuration) * 1000;
                this.expanded = false;
                setTimeout(function () {
                    _this.destroyPopper();
                    _this.opened = false;
                    _this.raulSelectClose.emit({ value: _this.value });
                }, transitionDuration);
                if (getScreenSize() == 'sm' && !this.isNoScroll)
                    document.body.classList.remove('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    /**
     * Toggle the select menu.
     */
    class_1.prototype.toggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.opened ? this.close() : this.open();
                return [2 /*return*/];
            });
        });
    };
    class_1.prototype.hasSlot = function (slotName) {
        return !!this.el.querySelector("[slot=" + slotName + "]");
    };
    class_1.prototype.matchSearchQuery = function (text) {
        return text.toLowerCase().indexOf(this.searchQuery) !== -1;
    };
    class_1.prototype.visibleOptionsAndGroups = function () {
        var _this = this;
        return this.processedOptions.filter(function (option) {
            if (option.options && option.options.length) {
                var someOptionsVisible = option.options.some(function (option) { return _this.matchSearchQuery(option.text); });
                return _this.matchSearchQuery(option.text) || someOptionsVisible;
            }
            else {
                return _this.matchSearchQuery(option.text);
            }
        });
    };
    class_1.prototype.setOptionsId = function () {
        this.options.forEach(function (option) {
            var _a;
            option.id = option.id ? option.id : "option-" + randomUID();
            if ((_a = option.options) === null || _a === void 0 ? void 0 : _a.length) {
                option.options.forEach(function (subOption) {
                    subOption.id = subOption.id ? subOption.id : "option-" + randomUID();
                });
            }
        });
    };
    class_1.prototype.optionsWithoutGroups = function () {
        return this.options.reduce(function (acc, cv) {
            if (cv.options && cv.options.length) {
                cv.options.forEach(function (option) { return acc.push(option); });
            }
            else {
                acc.push(cv);
            }
            return acc;
        }, []);
    };
    class_1.prototype.focusableOptionsAndGroups = function (visibleOptionsAndGroups) {
        var _this = this;
        var optionsAndGroups = visibleOptionsAndGroups ? visibleOptionsAndGroups : this.visibleOptionsAndGroups();
        var flattenedVisibleOptionsAndGroups = optionsAndGroups.reduce(function (acc, cv) {
            if (!cv.disabled) {
                acc.push(cv);
                if (cv.options && cv.options.length) {
                    cv.options.forEach(function (option) {
                        if (!option.disabled && (_this.matchSearchQuery(option.text) || _this.matchSearchQuery(cv.text))) {
                            acc.push(option);
                        }
                    });
                }
            }
            return acc;
        }, []);
        return this.multiple
            ? flattenedVisibleOptionsAndGroups
            : flattenedVisibleOptionsAndGroups.filter(function (option) { return !(option.options && option.options.length); });
    };
    class_1.prototype.selectedOptions = function () {
        var _this = this;
        var isSelected = function (optionValue) {
            return _this.multiple ? _this.value.includes(optionValue) : _this.value === optionValue;
        };
        return this.optionsWithoutGroups().filter(function (option) { return isSelected(option.value); });
    };
    class_1.prototype.selectedOptionsText = function () {
        var selectedOptions = this.selectedOptions();
        var selectedOptionsLength = selectedOptions.length;
        return this.customValue
            ? this.customValue
            : selectedOptionsLength > 1
                ? selectedOptionsLength + " options selected"
                : selectedOptions.map(function (option) { return option.text; }).join();
    };
    class_1.prototype.setInitialValue = function () {
        var optionsUseSelectedProp = this.options.filter(function (option) { return (option.hasOwnProperty('selected')); }).length > 0;
        if (optionsUseSelectedProp) {
            this.value = this.multiple ? [] : '';
        }
    };
    class_1.prototype.processOptions = function (start, end) {
        var _this = this;
        if (start === void 0) { start = 1; }
        if (end === void 0) { end = this.options.length; }
        var optionsHaveGroups = this.options.some(function (item) { return item.hasOwnProperty('options'); });
        if (optionsHaveGroups) {
            this.processGroupOptions(start, end);
        }
        else {
            var options_1 = this.processedOptions;
            this.filteredOptions = this.options.filter(function (option) { return option.text.toLowerCase().includes(_this.searchQuery); });
            this.filteredOptions.forEach(function (option, i) {
                if (option.selected)
                    _this.value = _this.multiple ? _this.value.concat(option.value) : option.value;
                if (start - 1 <= i && i < end) {
                    options_1.push(option);
                }
            });
            this.processedOptions = [];
            this.processedOptions = options_1;
        }
    };
    class_1.prototype.processGroupOptions = function (start, end) {
        var _this = this;
        var options = [];
        this.filteredOptions = cloneDeep(this.options).filter(function (option) {
            var _a;
            if ((_a = option.options) === null || _a === void 0 ? void 0 : _a.length) {
                option.options = option.options.filter(function (item) { return _this.matchSearchQuery(item.text); });
                var someOptionsVisible = option.options.some(function (option) { return _this.matchSearchQuery(option.text); });
                return _this.matchSearchQuery(option.text) || someOptionsVisible;
            }
        });
        cloneDeep(this.filteredOptions).map(function (option) {
            var _a;
            option = Object.assign({}, option);
            if ((_a = option.options) === null || _a === void 0 ? void 0 : _a.length) {
                option.options.forEach(function (subOption) {
                    if (subOption.selected)
                        _this.value = _this.multiple ? _this.value.concat(subOption.value) : subOption.value;
                });
            }
            if (option.selected)
                _this.value = _this.multiple ? _this.value.concat(option.value) : option.value;
            options.push(option);
        });
        var flattenedVisibleOptionsAndGroups = options.reduce(function (acc, cv) {
            acc.push(cv);
            if (cv.options && cv.options.length) {
                cv.options.forEach(function (option) {
                    option.parentId = cv.id;
                    acc.push(option);
                });
            }
            return acc;
        }, []);
        if (start >= flattenedVisibleOptionsAndGroups.length) { // the end of menu
            return;
        }
        var endId = end >= flattenedVisibleOptionsAndGroups.length ? flattenedVisibleOptionsAndGroups[flattenedVisibleOptionsAndGroups.length - 1].id : flattenedVisibleOptionsAndGroups[end].id;
        var parentIndex = 0;
        var optionIndex = 0;
        options.some(function (parent, i) {
            if (parent.id === endId) {
                parentIndex = i;
                return true;
            }
            if (parent.options && parent.options.length) {
                return parent.options.some(function (child, index) {
                    if (child.id === endId) {
                        parentIndex = i;
                        optionIndex = index;
                        return true;
                    }
                });
            }
        });
        options = options.slice(0, parentIndex + 1);
        options[parentIndex].options.length = optionIndex + 1;
        this.processedOptions = [];
        this.processedOptions = options;
    };
    class_1.prototype.validateValue = function () {
        var type = this.multiple ? 'array' : 'string';
        var isStringOrArray = this.multiple ? Array.isArray(this.value) : typeof this.value === 'string';
        if (!isStringOrArray && !this.custom) {
            throw new Error("value has to be " + type);
        }
    };
    class_1.prototype.focusOption = function (key) {
        var _this = this;
        var focusedOptionIndex;
        var focusableOptionsAndGroups = this.multiple ? [{ text: 'Select All', id: this.selectAllId }] : [];
        focusableOptionsAndGroups = __spreadArrays(focusableOptionsAndGroups, this.focusableOptionsAndGroups());
        if (document.activeElement === this.searchInputEl || document.activeElement === this.toggleButtonEl) {
            focusedOptionIndex = -1;
        }
        else {
            focusedOptionIndex = this.focusedOptionId
                ? focusableOptionsAndGroups.findIndex(function (option) { return option.id === _this.focusedOptionId; })
                : -1;
        }
        var focus = function (key) {
            if (focusedOptionIndex === 0 && key === 'up') {
                _this.focusedOptionId = _this.searchable && _this.searchInputEl ? _this.searchInputEl.id : null;
            }
            else {
                _this.focusedOptionId = key === 'down'
                    ? focusableOptionsAndGroups[focusedOptionIndex + 1].id
                    : focusableOptionsAndGroups[focusedOptionIndex - 1].id;
            }
            setTimeout(function () {
                _this.focusedOptionId && document.getElementById(_this.focusedOptionId).focus();
            });
        };
        if (DOWN_KEY.includes(key) && !(focusedOptionIndex >= focusableOptionsAndGroups.length - 1)) {
            focus('down');
        }
        else if (UP_KEY.includes(key) && !(focusedOptionIndex <= -1)) {
            focus('up');
        }
    };
    class_1.prototype.handleOptionChange = function (e, _b) {
        var id = _b.id, selected = _b.selected, value = _b.value;
        e.preventDefault();
        this.focusedOptionId = id;
        if (this.multiple) {
            this.value = selected ? __spreadArrays(this.value, [value]) : this.value.filter(function (optionValue) { return optionValue !== value; });
        }
        else {
            this.value = value;
            this.close();
            if (this.variant === 'select')
                this.toggleButtonEl.focus();
        }
        this.raulChange.emit({ value: this.value });
    };
    class_1.prototype.handleOptionsGroupChange = function (e, _b) {
        var id = _b.id, selected = _b.selected, group = _b.group;
        e.preventDefault();
        var allOptionsOfGroup = this.filteredOptions.find(function (item) { return item.id === group.id; }).options
            .filter(function (option) { return !option.disabled; })
            .map(function (option) { return option.value; });
        this.focusedOptionId = id;
        this.value = selected
            ? __spreadArrays(this.value, allOptionsOfGroup).filter(function (item, i, self) { return self.indexOf(item) === i; })
            : this.value.filter(function (option) { return !allOptionsOfGroup.includes(option); });
        this.raulChange.emit({ value: this.value });
    };
    class_1.prototype.handleSearch = function (e) {
        this.searchQuery = e.target.value.toLowerCase();
        if (this.menuBody) {
            this.menuBody.scrollTop = 0;
        }
        this.startPosition = 1;
        this.endPosition = 10;
        this.processedOptions = [];
        this.processOptions(this.startPosition, this.endPosition);
    };
    class_1.prototype.getValuesSelectAllGroupChange = function () {
        var _this = this;
        var optVals = [];
        var flattenedVisibleOptionsAndGroups = this.filteredOptions.reduce(function (acc, cv) {
            if (!cv.disabled) {
                acc.push(cv);
                if (cv.options && cv.options.length) {
                    cv.options.forEach(function (option) {
                        if (!option.disabled && (_this.matchSearchQuery(option.text) || _this.matchSearchQuery(cv.text))) {
                            acc.push(option);
                        }
                    });
                }
            }
            return acc;
        }, []);
        optVals = this.multiple ? flattenedVisibleOptionsAndGroups : flattenedVisibleOptionsAndGroups.filter(function (option) { return !(option.options && option.options.length); });
        optVals = optVals.filter(function (option) { return !option.options; }) // exclude group options
            .map(function (option) { return option.value; });
        return optVals;
    };
    class_1.prototype.handleSelectAllChange = function (e, _b) {
        var id = _b.id, selected = _b.selected;
        e.preventDefault();
        this.focusedOptionId = id;
        var optionsHaveGroups = this.options.some(function (item) { return item.hasOwnProperty('options'); });
        var optVals = [];
        if (optionsHaveGroups) {
            optVals = this.getValuesSelectAllGroupChange();
        }
        else {
            optVals = this.filteredOptions.map(function (item) { return item.value; });
        }
        this.value = selected ? this.value.filter(function (option) { return optVals.indexOf(option) === -1; }) : optVals;
        this.raulChange.emit({ value: this.value });
    };
    class_1.prototype.createPopper = function () {
        if (!this.popper) {
            this.popper = new Popper(this.toggleButtonEl ? this.toggleButtonEl : this.selectInputEl, this.selectMenuEl, {
                placement: this.menuPlacement,
                positionFixed: this.menuPositionFixed
            });
        }
    };
    class_1.prototype.destroyPopper = function () {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    };
    class_1.prototype.clearSearch = function () {
        var _this = this;
        this.searchQuery = '';
        this.startPosition = 1;
        this.endPosition = 10;
        this.processedOptions = [];
        if (this.menuBody) {
            this.menuBody.scrollTop = 0;
        }
        this.processOptions(this.startPosition, this.endPosition);
        setTimeout(function () { return _this.searchInputEl.focus(); }, 0);
    };
    class_1.prototype.getVisibleOptionValues = function () {
        return this.focusableOptionsAndGroups()
            .filter(function (option) { return !option.options; }) // exclude group options
            .map(function (option) { return option.value; });
    };
    class_1.prototype.scroll = function (e) {
        var menuHeight = this.menuBody.offsetHeight;
        var menuContentHeight = this.menuBodyContent.offsetHeight;
        var scrollEnd = menuContentHeight - menuHeight;
        if (e.target.scrollTop === scrollEnd) {
            this.startPosition = this.startPosition + 10;
            this.endPosition = this.endPosition + 10;
            this.processOptions(this.startPosition, this.endPosition);
        }
    };
    class_1.prototype.selectTimeSegment = function (el) {
        var isE11 = navigator.userAgent.search('Trident/') > -1;
        if (!isE11) {
            if (!el.selectionStart) {
                el.setSelectionRange(0, 2, 'forward');
                return;
            }
            if (el.selectionStart == 5 && this.variant === 'time-picker-twenty-four') {
                el.setSelectionRange(0, 2, 'forward');
                return;
            }
            if (el.selectionStart > 2 && el.selectionStart <= 6) {
                el.setSelectionRange(3, 5, 'forward');
                return;
            }
            if (el.selectionStart > 6 && el.selectionStart < 8) {
                el.setSelectionRange(6, 8, 'forward');
                return;
            }
            if (el.selectionStart < 3 || el.selectionStart >= 8) {
                el.setSelectionRange(0, 2, 'forward');
                return;
            }
        }
    };
    class_1.prototype.setRange = function (start, end) {
        this.inputStart = start;
        this.inputEnd = end;
    };
    class_1.prototype.handleKeyPress = function (e, el) {
        console.log('this.variant', this.variant);
        var isDriectionalArrow = e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'ArrowRight' || e.key === 'ArrowDown';
        var isDelete = e.key === 'Backspace' || e.key === 'Delete';
        var isTab = e.key === 'Tab';
        var isShiftTab = e.shiftKey && e.key === 'Tab';
        var keyIsNumber = !isNaN(Number(e.key));
        var isE11 = navigator.userAgent.search('Trident/') > -1;
        if (!isE11) {
            if (el.selectionStart <= 2 && !isDriectionalArrow && keyIsNumber) {
                if (Number(e.key) == 0 && Number(el.value.substr(0, 2)) == 0 && this.variant === 'time-picker') {
                    this.value = "12:" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
                if (Number(e.key) < 4 && Number(el.value.substr(0, 2)) == 2 && this.variant === 'time-picker-twenty-four') {
                    this.value = '2' + e.key + ":" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
                if (Number(e.key) == 2 && this.variant === 'time-picker-twenty-four') {
                    this.value = '0' + e.key + ":" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(0, 2);
                    return;
                }
                if (Number(e.key) <= 2 && Number(el.value.substr(0, 2)) == 1) {
                    console.log('548');
                    this.value = '1' + e.key + ":" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
                if (Number(e.key) <= 1) {
                    this.value = '0' + e.key + ":" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(0, 2);
                    return;
                }
                if (Number(e.key) > 1 && Number(el.value.substr(0, 2)) !== 1 && this.variant === 'time-picker') {
                    this.value = '0' + e.key + ":" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
                if (Number(e.key) > 2 && Number(el.value.substr(0, 2)) !== 1 && this.variant === 'time-picker-twenty-four') {
                    this.value = '0' + e.key + ":" + el.value.substr(3, 5);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
            }
            if (this.lastInputPosition === 0 && Number(e.key) == 2 && Number(el.value.substr(0, 2)) == 1 && this.variant === 'time-picker' && !isDriectionalArrow && !isDelete && keyIsNumber) {
                this.value = '1' + e.key + ":" + el.value.substr(3, 5);
                this.lastInputPosition = el.selectionStart;
                this.setRange(3, 5);
                return;
            }
            if (this.lastInputPosition === 0 && Number(el.value.substr(0, 2)) == 1 && this.variant === 'time-picker-twenty-four' && !isDriectionalArrow && !isDelete && keyIsNumber) {
                this.value = '1' + e.key + ":" + el.value.substr(3, 5);
                this.lastInputPosition = el.selectionStart;
                this.setRange(3, 5);
                return;
            }
            if (this.lastInputPosition === 0 && Number(e.key) < 4 && Number(el.value.substr(0, 2)) == 2 && this.variant === 'time-picker-twenty-four' && !isDriectionalArrow && !isDelete && keyIsNumber) {
                this.value = '2' + e.key + ":" + el.value.substr(3, 5);
                this.lastInputPosition = el.selectionStart;
                this.setRange(3, 5);
                return;
            }
            if ((el.selectionStart >= 3 && el.selectionStart < 5) && !isDriectionalArrow && !isDelete && keyIsNumber) {
                if (Number(el.value.substr(3, 3)) >= 0 && Number(el.value.substr(3, 3)) < 6) {
                    this.value = el.value.substr(0, 2) + ":" + (Number(el.value.substr(3, 3)) + e.key) + el.value.substr(5, 8);
                    this.lastInputPosition = el.selectionStart;
                    this.variant === 'time-picker-twenty-four' ? this.setRange(3, 5) : this.setRange(6, 8);
                    return;
                }
                if (Number(e.key) > 0 && Number(e.key) < 6) {
                    this.value = el.value.substr(0, 2) + ":" + ('0' + e.key) + el.value.substr(5, 8);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
                if (Number(e.key) > 5) {
                    this.value = el.value.substr(0, 2) + ":" + ('0' + e.key) + el.value.substr(5, 8);
                    this.lastInputPosition = el.selectionStart;
                    this.variant === 'time-picker-twenty-four' ? this.setRange(3, 5) : this.setRange(6, 8);
                    return;
                }
                if (Number(e.key) === 0) {
                    this.value = el.value.substr(0, 2) + ":" + ('0' + e.key) + el.value.substr(5, 8);
                    this.lastInputPosition = el.selectionStart;
                    this.setRange(3, 5);
                    return;
                }
            }
            if (this.lastInputPosition === 3 && Number(el.value.substr(3, 3)) > 0 && Number(el.value.substr(3, 3)) < 6 && !isDriectionalArrow && !isDelete && keyIsNumber) {
                this.value = el.value.substr(0, 2) + ":" + (Number(el.value.substr(3, 3)) + e.key) + el.value.substr(5, 8);
                this.lastInputPosition = null;
                this.variant === 'time-picker-twenty-four' ? this.setRange(3, 5) : this.setRange(6, 8);
                return;
            }
            if (this.lastInputPosition === 3 && Number(el.value.substr(3, 3)) > 0 && Number(el.value.substr(3, 3)) < 6 && !isDriectionalArrow && !isDelete && keyIsNumber) {
                this.value = el.value.substr(0, 2) + ":" + (Number(el.value.substr(3, 3)) + e.key) + el.value.substr(5, 8);
                this.lastInputPosition = null;
                this.variant === 'time-picker-twenty-four' ? this.setRange(3, 5) : this.setRange(6, 8);
                return;
            }
            if (this.lastInputPosition === 3 && Number(el.value.substr(3, 3)) > 5 && !isDriectionalArrow && !isDelete && keyIsNumber) {
                this.value = "" + el.value;
                this.lastInputPosition = null;
                this.variant === 'time-picker-twenty-four' ? this.setRange(3, 5) : this.setRange(6, 8);
                return;
            }
            if (el.selectionStart == 6 && (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key.toLowerCase() === 'a' || e.key.toLowerCase() === 'p')) {
                if (el.value.substr(6, 7) === '--' && e.key === 'ArrowUp')
                    this.value = el.value.substr(0, 2) + ":" + el.value.substr(3, 3) + "AM";
                if (el.value.substr(6, 7) === '--' && e.key === 'ArrowDown')
                    this.value = el.value.substr(0, 2) + ":" + el.value.substr(3, 3) + "PM";
                if (el.value.substr(6, 7) === 'AM')
                    this.value = el.value.substr(0, 2) + ":" + el.value.substr(3, 3) + "PM";
                if (el.value.substr(6, 7) === 'PM')
                    this.value = el.value.substr(0, 2) + ":" + el.value.substr(3, 3) + "AM";
                if (e.key.toLowerCase() === 'a')
                    this.value = el.value.substr(0, 2) + ":" + el.value.substr(3, 3) + "AM";
                if (e.key.toLowerCase() === 'p')
                    this.value = el.value.substr(0, 2) + ":" + el.value.substr(3, 3) + "PM";
                this.lastInputPosition = el.selectionStart;
                this.setRange(6, 8);
                return;
            }
            if (el.selectionStart <= 2 && e.key === 'ArrowUp') {
                var newHour = el.value.substr(0, 2) === '--' ? this.variant === 'time-picker' ? 1 : 0 : (this.variant === 'time-picker' && Number(el.value.substr(0, 2)) === 12) ? 1 : (this.variant === 'time-picker-twenty-four' && Number(el.value.substr(0, 2)) === 23) ? 0 : Number(el.value.substr(0, 2)) + 1;
                this.value = (newHour < 10 ? '0' + newHour : newHour) + ":" + el.value.substr(3, 5);
                this.lastInputPosition = null;
                this.setRange(0, 2);
                return;
            }
            if (el.selectionStart <= 2 && e.key === 'ArrowDown') {
                var newHour = el.value.substr(0, 2) === '--' ? this.variant === 'time-picker' ? 12 : 23 : Number(el.value.substr(0, 2)) === 0 ? 23 : (this.variant === 'time-picker' && Number(el.value.substr(0, 2)) === 1) ? 12 : Number(el.value.substr(0, 2)) - 1;
                this.value = (newHour < 10 ? '0' + newHour : newHour) + ":" + el.value.substr(3, 5);
                this.lastInputPosition = null;
                this.setRange(0, 2);
                return;
            }
            if ((el.selectionStart >= 3 && el.selectionStart < 5) && e.key === 'ArrowUp') {
                var newMin = el.value.split('')[3] === '-' && el.value.split('')[4] === '-' ? 0 : el.value.substr(3, 3) == 59 ? 0 : Number(el.value.substr(3, 3)) + 1;
                this.value = el.value.substr(0, 2) + ":" + (newMin < 10 ? '0' + newMin : newMin) + el.value.substr(5, 5);
                this.lastInputPosition = null;
                this.setRange(3, 5);
                return;
            }
            if ((el.selectionStart >= 3 && el.selectionStart < 5) && e.keyC === 'ArrowDown') {
                var newMin = el.value.split('')[3] === '-' && el.value.split('')[4] === '-' ? 59 : el.value.substr(3, 3) == 0 ? 59 : Number(el.value.substr(3, 3)) - 1;
                this.value = el.value.substr(0, 2) + ":" + (newMin < 10 ? '0' + newMin : newMin) + el.value.substr(5, 5);
                this.lastInputPosition = null;
                this.setRange(3, 5);
                return;
            }
            if (el.selectionStart == 0 && (e.key === 'ArrowRight' || (isTab && !isShiftTab))) {
                this.lastInputPosition = null;
                this.setRange(3, 5);
                return;
            }
            if (el.selectionStart == 3 && (e.key === 'ArrowLeft' || isShiftTab)) {
                this.lastInputPosition = null;
                this.setRange(0, 2);
                return;
            }
            if (this.variant === 'time-picker' && el.selectionStart == 3 && (e.key === 'ArrowRight' || (isTab && !isShiftTab))) {
                this.lastInputPosition = null;
                this.setRange(6, 8);
                return;
            }
            if (this.variant === 'time-picker' && el.selectionStart == 6 && (e.key === 'ArrowLeft' || isShiftTab)) {
                this.lastInputPosition = null;
                this.setRange(3, 5);
                return;
            }
            if (el.selectionStart == 0 && isDelete) {
                this.lastInputPosition = null;
                this.value = "--:" + el.value.substr(3, 5);
                this.setRange(0, 2);
                return;
            }
            if ((el.selectionStart >= 3 && el.selectionStart < 5) && isDelete) {
                this.lastInputPosition = null;
                this.value = el.value.substr(0, 2) + ":--" + el.value.substr(5, 5);
                this.setRange(3, 5);
                return;
            }
        }
    };
    class_1.prototype.render = function () {
        var _this = this;
        var visibleOptionsAndGroups = this.visibleOptionsAndGroups();
        var valueLength = this.value.length;
        var renderHiddenInput = function () {
            if (_this.multiple) {
                return _this.value && valueLength
                    ? _this.value.map(function (value) { return h("input", { type: "hidden", name: _this.name, value: value }); })
                    : h("input", { type: "hidden", name: _this.name, value: _this.value });
            }
            else {
                return h("input", { type: "hidden", name: _this.name, value: _this.value });
            }
        };
        var renderSelectToggleContent = function () {
            if (!_this.hasSlot('select-toggle')) {
                var selectedOptionsText = _this.selectedOptionsText();
                return (h("div", { class: {
                        'r-select__toggle__content': true,
                        'r-select__toggle__content--borderless': _this.borderless,
                        'r-select__toggle__content--header': _this.header
                    } }, h("div", { class: {
                        'r-select__toggle__content__outline__leading': true,
                        'r-select__toggle__content__outline__leading--float': !(selectedOptionsText === null || selectedOptionsText === ''),
                    } }), h("div", { class: {
                        'r-select__toggle__content__outline__notch': true,
                        'r-select__toggle__content__outline__notch--float': _this.compact && !(selectedOptionsText === null || selectedOptionsText === '')
                    } }, _this.compact &&
                    h("label", { class: {
                            'r-select__toggle__content__label': true,
                            'r-select__toggle__content__label--float': _this.compact && !(selectedOptionsText === null || selectedOptionsText === '')
                        } }, _this.label)), h("div", { class: "r-select__toggle__content__outline__trailing" }, _this.variant === 'select' ? h("span", { class: "r-select__toggle__content__arrow" }) : h("raul-icon", { icon: "clock", class: "r-select__toggle__content__icon" })), h("div", { class: "r-select__toggle__content__text" }, !_this.compact ? selectedOptionsText || _this.placeholder : selectedOptionsText)));
            }
        };
        var renderTextInput = function () {
            return (h("div", { class: {
                    'r-select__toggle__content': true,
                    'r-select__toggle__content--borderless': _this.borderless,
                    'r-select__toggle__content--focus': _this.isFocused
                } }, h("div", { class: {
                    'r-select__toggle__content__outline__leading': true,
                    'r-select__toggle__content__outline__leading--float': _this.compact && (_this.value.length > 0 || !(_this.customValue === null || _this.customValue === '')),
                } }), h("div", { class: {
                    'r-select__toggle__content__outline__notch': true,
                    'r-select__toggle__content__outline__notch--float': _this.compact && (_this.value.length > 0 || !(_this.customValue === null || _this.customValue === ''))
                } }, _this.compact &&
                h("label", { class: {
                        'r-select__toggle__content__label': true,
                        'r-select__toggle__content__label--float': _this.compact && (_this.value.length > 0 || !(_this.customValue === null || _this.customValue === ''))
                    } }, _this.label)), h("div", { class: "r-select__toggle__content__outline__trailing r-cursor-pointer", onClick: function () { return _this.toggle(); } }, _this.variant === 'select' ? h("span", { class: "r-select__toggle__content__arrow" }) : h("raul-icon", { icon: "clock", class: "r-select__toggle__content__icon" })), h("input", { ref: function (el) { return _this.selectInputEl = el; }, class: { 'r-select__toggle__content__input': true, 'r-select__toggle__content__input--masked': _this.variant.includes('time-picker') }, type: "text", value: _this.value, placeholder: _this.placeholder, onChange: function () { return _this.variant.includes('time-picker') ? _this.raulChange.emit({ value: _this.selectInputEl.value === '--:--' || _this.selectInputEl.value === '--:-- --' ? null : _this.selectInputEl.value, onChange: true }) : null; }, onFocus: function () { return _this.isFocused = true; }, onBlur: function () { return _this.isFocused = false; }, onClick: function () { return _this.variant.includes('time-picker') ? _this.selectTimeSegment(_this.selectInputEl) : null; }, onKeyUp: function (e) {
                    if (_this.variant.includes('time-picker')) {
                        if (!(navigator.userAgent.search('Trident/') > -1)) {
                            e.preventDefault();
                            _this.selectInputEl.setSelectionRange(_this.inputStart, _this.inputEnd, 'forward');
                        }
                        if (!(e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Tab' || (e.shiftKey && e.key === 'Tab')))
                            _this.raulChange.emit({ value: _this.selectInputEl.value === '--:--' || _this.selectInputEl.value === '--:-- --' ? null : _this.selectInputEl.value });
                    }
                }, onKeyDown: function (e) {
                    if (_this.variant.includes('time-picker')) {
                        if (!(navigator.userAgent.search('Trident/') > -1))
                            e.preventDefault();
                        _this.handleKeyPress(e, _this.selectInputEl);
                    }
                } })));
        };
        var renderSelectMenuFooter = function () {
            if (_this.hasSlot('select-menu-footer')) {
                return (h("div", { class: "r-select__menu__footer" }, h("slot", { name: "select-menu-footer" })));
            }
        };
        var renderSelectMenuMobileLabelContent = function () {
            if (!_this.hasSlot('select-mobile-label')) {
                return (h("div", { class: "r-select__mobile-label__content" }, h("div", { class: "r-select__mobile-label__content__button" }, h("span", { onClick: function () { return _this.close(); } }, _this.custom ? 'Close' : 'Cancel')), _this.label &&
                    h("div", { class: "r-select__mobile-label__content__text" }, _this.label), _this.multiple &&
                    h("div", { class: {
                            'r-select__mobile-label__content__button': true,
                            'r-select__mobile-label__content__button--right': true,
                            'r-select__mobile-label__content__button--disabled': false
                        } }, h("span", { onClick: function () { return _this.close(); } }, "Done"))));
            }
        };
        var renderSelectMenuSearch = function () {
            if (_this.searchable) {
                return (h("div", { class: "r-select__search" }, _this.opened && h("raul-icon", { icon: "search", class: "r-select__search__icon" }), h("input", { type: "text", class: "r-select__search__input", placeholder: "Search", value: _this.searchQuery, onInput: function (e) { return _this.handleSearch(e); }, id: _this.searchInputId, ref: function (el) { return _this.searchInputEl = el; } }), _this.searchQuery &&
                    h("raul-icon", { icon: "remove-2", class: "r-select__search__icon-reset", onClick: function () { return _this.clearSearch(); } })));
            }
        };
        var renderNoSearchResults = function () {
            if (_this.processedOptions.length && !visibleOptionsAndGroups.length) {
                return (h("div", { class: "r-select__no-search-results" }, "No results found. Try changing your search criteria."));
            }
        };
        var renderSelectMenuHeader = function () {
            return (h("div", { class: "r-select__menu__header" }, h("div", { class: "r-select__mobile-label" }, renderSelectMenuMobileLabelContent(), h("slot", { name: "select-mobile-label" })), renderSelectMenuSearch(), renderNoSearchResults(), renderNoOptionsMessage()));
        };
        var renderOption = function (option, groupVisible, groupDisabled) {
            if (groupVisible === void 0) { groupVisible = false; }
            if (groupDisabled === void 0) { groupDisabled = false; }
            var id = option.id, text = option.text, description = option.description, disabled = option.disabled, icon = option.icon, iconKind = option.iconKind, variant = option.variant, value = option.value;
            var visible = _this.matchSearchQuery(text) || groupVisible;
            var focused = id === _this.focusedOptionId;
            var selected = _this.multiple ? _this.value.includes(value) : _this.value === value;
            var isDisabled = disabled || groupDisabled;
            if (visible) {
                return (h("raul-option", { multiple: _this.multiple, selected: selected, focused: focused, disabled: isDisabled, value: value, text: text, description: description, icon: icon, iconKind: iconKind, optionId: id, variant: variant, onClick: function (e) { return _this.handleOptionChange(e, { id: id, selected: _this.multiple ? !selected : true, value: value }); }, onKeyDown: function (e) { return e.key === 'Enter'
                        ? _this.handleOptionChange(e, { id: id, selected: _this.multiple ? !selected : true, value: value })
                        : null; } }));
            }
        };
        var renderOptionsGroup = function (group) {
            var id = group.id, text = group.text, description = group.description, disabled = group.disabled, value = group.value, options = group.options;
            var visibleOptionValues = _this.getVisibleOptionValues();
            var optionsValues = options
                .map(function (option) { return option.value; })
                .filter(function (option) { return visibleOptionValues.includes(option); });
            var groupVisible = _this.matchSearchQuery(text);
            var focused = id === _this.focusedOptionId;
            var selected = _this.multiple && _this.value.length && optionsValues.length ? optionsValues.every(function (option) { return _this.value.includes(option); }) : false;
            var indeterminate = _this.multiple
                ? !selected && optionsValues.some(function (option) { return _this.value.includes(option); })
                : false;
            var enabledOptionsSelected = _this.multiple
                ? optionsValues.every(function (option) { return _this.value.includes(option); })
                : false;
            return (h("div", { class: "r-options-group", role: "group" }, h("raul-option", { variant: "group", multiple: _this.multiple, selected: selected, focused: focused, disabled: disabled, value: value, text: text, description: description, indeterminate: indeterminate, optionId: id, onClick: _this.multiple
                    ? function (e) { return _this.handleOptionsGroupChange(e, { id: id, selected: !enabledOptionsSelected, group: group }); }
                    : null, onKeyDown: function (e) { return _this.multiple && e.key === 'Enter'
                    ? _this.handleOptionsGroupChange(e, { id: id, selected: !enabledOptionsSelected, group: group })
                    : null; } }), options.map(function (option) { return renderOption(option, groupVisible, disabled); })));
        };
        var setSelectAllGroupProps = function () {
            var flattenedVisibleOptionsAndGroups = _this.filteredOptions.reduce(function (acc, cv) {
                if (!cv.disabled) {
                    acc.push(cv);
                    if (cv.options && cv.options.length) {
                        cv.options.forEach(function (option) {
                            if (!option.disabled && (_this.matchSearchQuery(option.text) || _this.matchSearchQuery(cv.text))) {
                                acc.push(option);
                            }
                        });
                    }
                }
                return acc;
            }, []);
            flattenedVisibleOptionsAndGroups = _this.multiple ? flattenedVisibleOptionsAndGroups : flattenedVisibleOptionsAndGroups.filter(function (option) { return !(option.options && option.options.length); });
            flattenedVisibleOptionsAndGroups = flattenedVisibleOptionsAndGroups.filter(function (option) { return !option.options; }) // exclude group options
                .map(function (option) { return option.value; });
            var selected = flattenedVisibleOptionsAndGroups.length && flattenedVisibleOptionsAndGroups.every(function (item) { return _this.value.indexOf(item) !== -1; });
            var indeterminate = !selected && flattenedVisibleOptionsAndGroups.some(function (item) { return _this.value.indexOf(item) !== -1; });
            var disabled = !flattenedVisibleOptionsAndGroups.length;
            return { selected: selected, indeterminate: indeterminate, disabled: disabled };
        };
        var renderSelectAllOption = function () {
            var selectedVisibleOptions = _this.filteredOptions.filter(function (item) { return _this.value.indexOf(item.value) !== -1; });
            var selectedVisibleOptionsLength = selectedVisibleOptions.length;
            var filteredOptionsLength = _this.filteredOptions.length;
            var indeterminate = !!selectedVisibleOptionsLength && filteredOptionsLength !== selectedVisibleOptionsLength;
            var selected = selectedVisibleOptionsLength && filteredOptionsLength === selectedVisibleOptionsLength;
            var optionsHaveGroups = _this.options.some(function (item) { return item.hasOwnProperty('options'); });
            var focused = _this.selectAllId === _this.focusedOptionId;
            var disabled = false;
            if (optionsHaveGroups) {
                selected = setSelectAllGroupProps().selected;
                indeterminate = setSelectAllGroupProps().indeterminate;
                disabled = setSelectAllGroupProps().disabled;
            }
            if (_this.focusableOptionsAndGroups(visibleOptionsAndGroups).length) {
                return (h("raul-option", { text: "Select All", variant: "group", multiple: _this.multiple, selected: selected, indeterminate: indeterminate, disabled: disabled, focused: focused, optionId: _this.selectAllId, onClick: function (e) { return _this.handleSelectAllChange(e, { id: _this.selectAllId, selected: selected }); }, onKeyDown: function (e) { return e.key === 'Enter' ? _this.handleSelectAllChange(e, { id: _this.selectAllId, selected: selected }) : null; } }));
            }
        };
        var renderNoOptionsMessage = function () {
            if (_this.showNoOptionsMessage) {
                return h("div", { class: "r-select__no-options" }, _this.noOptionsMessage);
            }
        };
        var renderCustomSelect = function () {
            return ([
                _this.hiddenInput && renderHiddenInput(),
                _this.label && !_this.compact && h("label", { class: "r-select__label" }, _this.label),
                h("div", { class: {
                        'r-select': true,
                        'r-select--opened': _this.opened,
                        'r-select--expanded': _this.expanded,
                        'r-select--invalid': !!_this.error,
                    }, ref: function (el) { return _this.selectEl = el; } }, h("button", { type: "button", class: "r-select__toggle", disabled: _this.disabled, "aria-haspopup": "true", "aria-expanded": _this.opened ? 'true' : 'false', onClick: function () { return _this.toggle(); }, ref: function (el) { return _this.toggleButtonEl = el; } }, h("div", { class: {
                        'r-select__toggle__content': true,
                        'r-select__toggle__content--borderless': _this.borderless,
                        'r-select__toggle__content--header': _this.header,
                    } }, h("div", { class: {
                        'r-select__toggle__content__outline__leading': true,
                        'r-select__toggle__content__outline__leading--float': _this.compact && (valueLength > 0 || !(_this.customValue === null || _this.customValue === '')),
                    } }), h("div", { class: {
                        'r-select__toggle__content__outline__notch': true,
                        'r-select__toggle__content__outline__notch--float': _this.compact && (valueLength > 0 || !(_this.customValue === null || _this.customValue === '')),
                    } }, _this.compact &&
                    h("label", { class: {
                            'r-select__toggle__content__label': true,
                            'r-select__toggle__content__label--float': _this.compact && (valueLength > 0 || !(_this.customValue === null || _this.customValue === ''))
                        } }, _this.label)), h("div", { class: "r-select__toggle__content__outline__trailing" }, _this.variant === 'select' ? h("span", { class: "r-select__toggle__content__arrow" }) : h("raul-icon", { icon: "clock", class: "r-select__toggle__content__icon" })), h("div", { class: "r-select__toggle__content__text" }, _this.customValue ? _this.customValue : Array.isArray(_this.value) && valueLength > 1 ? valueLength + " options selected" : (valueLength ? _this.value : _this.compact ? null : _this.placeholder)))), _this.hint && h("small", { class: "r-select__hint" }, _this.hint), _this.error &&
                    h("div", { class: "r-select__error" }, h("raul-icon", { icon: "interface-alert-diamond", class: "r-select__error__icon" }), " ", _this.error), h("div", { class: "r-select__menu", ref: function (el) { return _this.selectMenuEl = el; } }, h("div", { class: {
                        'r-select__menu__content': true,
                        'md:r-max-h-xl': !_this.overflow
                    } }, _this.loading && h("raul-container-loader", null), renderSelectMenuHeader(), _this.showNoOptionsMessage &&
                    h("div", { class: "r-select__menu__header" }, renderNoOptionsMessage()), !_this.showNoOptionsMessage &&
                    h("div", { class: {
                            'r-select__menu__body': true,
                            'r-overflow-visible': _this.overflow
                        }, role: "listbox", tabindex: "-1", style: { maxHeight: _this.optionsMaxHeight } }, h("slot", null)))))
            ]);
        };
        var flattenedVisibleOptionsAndGroups = this.options.reduce(function (acc, cv) {
            acc.push(cv);
            if (cv.options && cv.options.length) {
                cv.options.forEach(function (option) {
                    if (_this.matchSearchQuery(option.text) || _this.matchSearchQuery(cv.text)) {
                        acc.push(option);
                    }
                });
            }
            return acc;
        }, []);
        if (this.custom) { // custom select
            return renderCustomSelect();
        }
        else { // data-driven select
            return [
                this.hiddenInput && renderHiddenInput(),
                this.label && !this.compact && h("label", { class: "r-select__label" }, this.label),
                h("div", { class: {
                        'r-select': true,
                        'r-select--opened': this.opened,
                        'r-select--expanded': this.expanded,
                        'r-select--header': this.header,
                        'r-select--invalid': !!this.error,
                    }, ref: function (el) { return _this.selectEl = el; } }, !this.textInput && h("button", { type: "button", class: {
                        'r-select__toggle': true,
                        'r-select__toggle--header': this.header,
                    }, disabled: this.disabled, "aria-haspopup": "true", "aria-expanded": this.opened ? 'true' : 'false', "aria-activedescendant": this.focusedOptionId, onClick: function () { return _this.toggle(); }, ref: function (el) { return _this.toggleButtonEl = el; } }, renderSelectToggleContent(), h("slot", { name: "select-toggle" })), this.textInput && renderTextInput(), this.hint && h("small", { class: "r-select__hint" }, this.hint), this.error &&
                    h("div", { class: "r-select__error" }, h("raul-icon", { icon: "interface-alert-diamond", class: "r-select__error__icon" }), " ", this.error), h("div", { class: "r-select__menu", ref: function (el) { return _this.selectMenuEl = el; } }, h("div", { class: "r-select__menu__content r-max-h-xl" }, this.loading && h("raul-container-loader", null), renderSelectMenuHeader(), h("div", { class: "r-select__menu__body", role: "listbox", tabindex: "-1", "aria-multiselectable": this.multiple ? 'true' : null, ref: function (el) { return _this.menuBody = el; }, style: { maxHeight: this.optionsMaxHeight }, onScroll: function (e) { return !_this.custom && flattenedVisibleOptionsAndGroups.length > 10 ? _this.scroll(e) : null; }, onKeyDown: function (e) { return !_this.custom && flattenedVisibleOptionsAndGroups.length > 10 && DOWN_KEY.includes(e.key) ? _this.scroll(e) : null; } }, h("div", { ref: function (el) { return _this.menuBodyContent = el; } }, this.multiple && renderSelectAllOption(), visibleOptionsAndGroups.map(function (option) {
                    return option.options && option.options.length
                        ? renderOptionsGroup(option)
                        : renderOption(option);
                }))), renderSelectMenuFooter())))
            ];
        }
    };
    Object.defineProperty(class_1.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "watchers", {
        get: function () {
            return {
                "options": ["optionsChanged"],
                "value": ["valueChanged"],
                "multiple": ["multipleChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "style", {
        get: function () { return "raul-select{display:block;font-size:.875rem}raul-select .r-select{position:relative}raul-select .r-select__label{--text-opacity:1;color:#37474f;color:rgba(55,71,79,var(--text-opacity))}raul-select .r-select__toggle{display:block;background-color:transparent;border-width:0;cursor:pointer;padding:0;text-align:left;outline:2px solid transparent;outline-offset:2px;width:100%}raul-select .r-select__toggle__content{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:.875rem;height:2.5rem;line-height:1.25;-ms-flex-positive:1;flex-grow:1;position:relative;background-color:var(--raul-select-bg,#fff);border-radius:var(--raul-select-border-radius,.125rem);color:var(--raul-select-color,#37474f)}raul-select .r-select__toggle__content__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-ms-flex-positive:1;flex-grow:1;font-size:1rem;position:absolute;width:100%;top:0;left:0;padding:.75rem 34px .75rem .75rem}\@media (min-width:1024px){raul-select .r-select__toggle__content__text{font-size:.875rem}}raul-select .r-select__toggle__content__input{border-width:1px;border-color:transparent;letter-spacing:.025em;display:block;font-size:1rem;height:2.5rem;padding-left:.75rem;padding-right:.75rem;position:absolute;top:0;left:0;background-color:transparent;-webkit-appearance:none;border-radius:var(--raul-input-border-radius,.125rem);color:var(--raul-input-color,#37474f);width:calc(100% - 32px)}raul-select .r-select__toggle__content__input::-moz-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__toggle__content__input:-ms-input-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__toggle__content__input::-webkit-input-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__toggle__content__input::-ms-input-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__toggle__content__input::placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__toggle__content__input[disabled]{--bg-opacity:1;background-color:#ebedee;background-color:rgba(235,237,238,var(--bg-opacity));--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity));--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity));cursor:not-allowed;z-index:-1}raul-select .r-select__toggle__content__input:focus{outline:2px solid transparent;outline-offset:2px}raul-select .r-select__toggle__content__input:invalid{--border-opacity:1;border-color:#d01a1f;border-color:rgba(208,26,31,var(--border-opacity))}\@media (min-width:1024px){raul-select .r-select__toggle__content__input{font-size:.875rem}}raul-select .r-select__toggle__content__input--masked{color:transparent;text-shadow:0 0 0 #37474f}raul-select .r-select__toggle__content__icon{font-size:1rem;--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity));margin-left:.5rem}raul-select .r-select__toggle__content__arrow{display:inline-block;border-left-width:1px;border-top-width:1px;margin-top:-.25rem;--border-opacity:1;border-color:#9ba3a7;border-color:rgba(155,163,167,var(--border-opacity));height:7px;-webkit-transform:rotate(-135deg);transform:rotate(-135deg);width:7px}raul-select .r-select__toggle__content__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:.875rem;margin-bottom:0;-webkit-transition:all .15s ease;transition:all .15s ease}raul-select .r-select__toggle__content__label--float{font-size:.75rem;position:relative;font-weight:500;margin-top:-38px}raul-select .r-select__toggle__content__outline__leading{border-width:1px;--border-opacity:1;border-color:#c6ccd0;border-color:rgba(198,204,208,var(--border-opacity));border-right-width:0;padding-left:.75rem;height:100%;border-radius:var(--raul-select-border-radius,.125rem);border-top-right-radius:0;border-bottom-right-radius:0}raul-select .r-select__toggle__content__outline__leading--float{padding-left:7px}raul-select .r-select__toggle__content__outline__notch{border-width:1px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;--border-opacity:1;border-color:#c6ccd0;border-color:rgba(198,204,208,var(--border-opacity));border-right-width:0;border-left-width:0;height:100%}raul-select .r-select__toggle__content__outline__notch--float{border-top-width:0;padding-left:.25rem;padding-right:.25rem}raul-select .r-select__toggle__content__outline__trailing{border-width:1px;--border-opacity:1;border-color:#c6ccd0;border-color:rgba(198,204,208,var(--border-opacity));display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-positive:1;flex-grow:1;border-left-width:0;padding-right:.75rem;height:100%;border-radius:var(--raul-select-border-radius,.125rem);border-top-left-radius:0;border-bottom-left-radius:0}raul-select .r-select__toggle__content--borderless .r-select__toggle__content__outline__leading,raul-select .r-select__toggle__content--borderless .r-select__toggle__content__outline__notch,raul-select .r-select__toggle__content--borderless .r-select__toggle__content__outline__trailing{border-color:transparent}raul-select .r-select__toggle__content--header{border-width:1px;--bg-opacity:1;background-color:#f7f8f9;background-color:rgba(247,248,249,var(--bg-opacity));border-color:transparent;margin-left:-8px}raul-select .r-select__toggle__content--header .r-select__toggle__content__outline__leading,raul-select .r-select__toggle__content--header .r-select__toggle__content__outline__notch{border-color:transparent;display:none}raul-select .r-select__toggle__content--header .r-select__toggle__content__outline__trailing{border-color:transparent;-ms-flex-order:2;order:2}raul-select .r-select__toggle__content--header .r-select__toggle__content__text{font-size:1.25rem;font-weight:700;position:relative;-ms-flex-order:1;order:1;padding:.5rem .75rem}raul-select .r-select__toggle__content--header .r-select__toggle__content__arrow{border-left-width:2px;border-top-width:2px;--border-opacity:1;border-color:#202737;border-color:rgba(32,39,55,var(--border-opacity))}raul-select .r-select__toggle__content--header:hover{--bg-opacity:1;background-color:#ebedee;background-color:rgba(235,237,238,var(--bg-opacity))}raul-select .r-select__toggle__content--focus .r-select__toggle__content__outline__leading,raul-select .r-select__toggle__content--focus .r-select__toggle__content__outline__notch,raul-select .r-select__toggle__content--focus .r-select__toggle__content__outline__trailing{--border-opacity:1;border-color:#0076cc;border-color:rgba(0,118,204,var(--border-opacity))}raul-select .r-select__toggle:focus{outline:2px solid transparent;outline-offset:2px}raul-select .r-select__toggle:focus .r-select__toggle__content--header,raul-select .r-select__toggle:focus .r-select__toggle__content__outline__leading,raul-select .r-select__toggle:focus .r-select__toggle__content__outline__notch,raul-select .r-select__toggle:focus .r-select__toggle__content__outline__trailing{--border-opacity:1;border-color:#0076cc;border-color:rgba(0,118,204,var(--border-opacity))}raul-select .r-select__toggle:focus .r-select__toggle__content--header .r-select__toggle__content__outline__trailing{border-color:transparent}raul-select .r-select__toggle:disabled .r-select__toggle__content{--bg-opacity:1;background-color:#ebedee;background-color:rgba(235,237,238,var(--bg-opacity));--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity));cursor:not-allowed}raul-select .r-select__toggle:disabled .r-select__toggle__content .r-select__toggle__content__outline__leading,raul-select .r-select__toggle:disabled .r-select__toggle__content .r-select__toggle__content__outline__notch,raul-select .r-select__toggle:disabled .r-select__toggle__content .r-select__toggle__content__outline__trailing{--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity))}raul-select .r-select__label{display:inline-block;font-weight:500;font-size:.75rem;margin-bottom:.25rem}raul-select .r-select__hint{display:block;font-size:.75rem;margin-top:.5rem}raul-select .r-select__error{display:-ms-flexbox;display:flex;font-size:.75rem;-ms-flex-align:center;align-items:center;--text-opacity:1;color:#d01a1f;color:rgba(208,26,31,var(--text-opacity));margin-top:.5rem}raul-select .r-select__error__icon{font-size:1rem;margin-right:.25rem}raul-select .r-select__menu{-ms-flex-direction:row;flex-direction:row;border-top-width:1px;border-bottom-width:1px;--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity));-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);position:absolute;left:0;top:100%;min-width:10rem;width:100%;margin-top:.5rem;margin-bottom:.5rem;display:none;opacity:0;background-color:var(--raul-select-menu-bg,#fff);border-radius:var(--raul-select-menu-border-radius,.125rem);-webkit-transition:opacity .2s ease,scale .2s linear;transition:opacity .2s ease,scale .2s linear;z-index:100000}raul-select .r-select__menu__content{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;min-height:2.5rem}\@media (max-width:640px){raul-select .r-select__menu__content{max-height:none}}raul-select .r-select__menu__body{-ms-flex-positive:1;flex-grow:1;overflow:auto}\@media (max-width:640px){raul-select .r-select__menu{top:0;right:0;bottom:0;left:0;-webkit-box-shadow:none;box-shadow:none;margin:0;min-width:0;position:fixed;border-width:0;border-radius:0;-webkit-transform:scale(0);transform:scale(0)}}raul-select .r-select__mobile-label{display:none}\@media (max-width:640px){raul-select .r-select__mobile-label{display:block}raul-select .r-select__mobile-label__content{-ms-flex-align:center;align-items:center;border-bottom-width:1px;--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity));--bg-opacity:1;background-color:#f7f8f9;background-color:rgba(247,248,249,var(--bg-opacity));display:-ms-flexbox;display:flex;font-size:.875rem;height:2.5rem}raul-select .r-select__mobile-label__content__button,raul-select .r-select__mobile-label__content__text{width:33.333333%}raul-select .r-select__mobile-label__content__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;--text-opacity:1;color:#37474f;color:rgba(55,71,79,var(--text-opacity));font-weight:500;text-align:center}raul-select .r-select__mobile-label__content__button{--text-opacity:1;color:#0076cc;color:rgba(0,118,204,var(--text-opacity));padding-left:.75rem;padding-right:.75rem}raul-select .r-select__mobile-label__content__button--disabled{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__mobile-label__content__button--right{margin-left:auto;text-align:right}}raul-select .r-select__search{--text-opacity:1;color:#37474f;color:rgba(55,71,79,var(--text-opacity));font-size:.75rem;position:relative}raul-select .r-select__search__input{border-width:1px;border-top-width:0;--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity));height:2.5rem;padding-left:2rem;padding-right:.75rem;width:100%}raul-select .r-select__search__input:focus{outline:1px solid #0076cc;outline-offset:-1px}raul-select .r-select__search__input::-moz-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__search__input:-ms-input-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__search__input::-webkit-input-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__search__input::-ms-input-placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-select__search__input::placeholder{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}\@media (max-width:640px){raul-select .r-select__search__input{border-left-width:0;border-right-width:0}}raul-select .r-select__search__icon{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity));left:.75rem}raul-select .r-select__search__icon,raul-select .r-select__search__icon-reset{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}raul-select .r-select__search__icon-reset{cursor:pointer;right:.75rem}raul-select .r-select__no-options,raul-select .r-select__no-search-results{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:.75rem;--text-opacity:1;color:#37474f;color:rgba(55,71,79,var(--text-opacity));padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;padding-right:1rem;min-height:.75rem}raul-select .r-select--opened>.r-select__menu{display:-ms-flexbox;display:flex}raul-select .r-select--expanded .r-select__menu{opacity:1}\@media (max-width:640px){raul-select .r-select--expanded .r-select__menu{-webkit-transform:scale(1);transform:scale(1)}}raul-select .r-select--invalid .r-select__toggle__content{--border-opacity:1;border-color:#d01a1f;border-color:rgba(208,26,31,var(--border-opacity))}\@media (min-width:640px){raul-select .r-select--header .r-select__menu{width:320px}}raul-select .r-option{border-width:1px;--border-opacity:1;border-color:#ebedee;border-color:rgba(235,237,238,var(--border-opacity));border-top-width:0;font-size:.75rem;cursor:pointer;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:1rem;padding-right:1rem;padding-top:.5rem;padding-bottom:.5rem;white-space:nowrap;line-height:1.25;min-height:2.5rem}raul-select .r-option,raul-select .r-option__icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}raul-select .r-option__icon{--bg-opacity:1;background-color:#ebedee;background-color:rgba(235,237,238,var(--bg-opacity));border-radius:9999px;--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity));font-size:1rem;height:2rem;width:2rem;margin-right:1rem}raul-select .r-option__icon raul-icon{display:-ms-inline-flexbox;display:inline-flex}raul-select .r-option__text{--text-opacity:1;color:#37474f;color:rgba(55,71,79,var(--text-opacity));-ms-flex:1 1 0%;flex:1 1 0%;padding-right:.75rem}raul-select .r-option__text,raul-select .r-option__text__description,raul-select .r-option__text__title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}raul-select .r-option__text__description{margin-top:.25rem}raul-select .r-option__check-mark{display:inline-block;border-left-width:1px;border-top-width:1px;margin-top:-.25rem;--border-opacity:1;border-color:#0076cc;border-color:rgba(0,118,204,var(--border-opacity));height:10px;-webkit-transform:rotate(-138deg);transform:rotate(-138deg);width:4px}raul-select .r-option:not(.r-option--group):hover{--bg-opacity:1;background-color:#f7f8f9;background-color:rgba(247,248,249,var(--bg-opacity))}body[modality=keyboard] raul-select .r-option:focus{outline:1px solid #0076cc;outline-offset:-1px}raul-select .r-option--selected .r-option__check-mark{opacity:1}raul-select .r-option--disabled{pointer-events:none}raul-select .r-option--disabled .r-option__check-mark,raul-select .r-option--disabled .r-option__text{--text-opacity:1;color:#9ba3a7;color:rgba(155,163,167,var(--text-opacity))}raul-select .r-option--group,raul-select .r-option--heading{background-color:transparent;padding-top:1.5rem;padding-bottom:1rem}raul-select .r-option--group .r-option__text__title,raul-select .r-option--heading .r-option__text__title{font-weight:600}raul-select .r-option--group:not(.r-option--multiple){cursor:auto}raul-select .r-option--sub-option{padding-left:1.5rem}raul-select .r-option--with-description .r-option__text__title{font-weight:600}\@media (max-width:640px){raul-select .r-option{border-left-width:0;border-right-width:0}}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
export { RaulCheckbox as raul_checkbox, RaulcontainerLoader as raul_container_loader, RaulOption as raul_option, RaulSelect as raul_select };
